import React from 'react'
import { ACTIVE_BOX_BG_COLOR, NAV_BOX_TEXT_COLOR } from '../../utils/ColorPicker'
import { CHEVRON_RIGHT, CHEVRON_RIGHT_ACTIVE } from '../../utils/constants'
import { useSelector } from 'react-redux';

const SelectNavBox = ({label, leftNavComponent, rightNavComponent, isActive, setActiveTab, showNoCursorPointer = false, customOnClickFn}) => {
  const { userDomain } = useSelector((state) => state.domain.selectedDomainDetails);
  
  const navBoxStyle = {
    backgroundColor: isActive ? ACTIVE_BOX_BG_COLOR : "white",
    color: isActive ? "white" : NAV_BOX_TEXT_COLOR,
    cursor: !showNoCursorPointer && "pointer"
  }

  //do not pass 'label' as props if the tab never gets active, use 'leftComponentLabel' function .
  
  // if the tab is going to be active with a right arrow (chevron) then just pass label as props and build the acitve tab function , 
  // take reference from SettingsContainer.js -> SettingsLHS and SettingsRHS 

  return (
    <div onClick={customOnClickFn ? customOnClickFn : label && (() => setActiveTab(label))} className='nav-box-container !py-3 !px-3 rounded-7 flex items-center justify-between border border-gray-100' style={navBoxStyle}>
        {
          leftNavComponent 
          ?
          leftNavComponent
          :
          <div className={`nav-box-label ${userDomain}_semi_bold_font`}>{label}</div>
        }
        {
          rightNavComponent
          ?
          rightNavComponent
          :
          <div>
            <img src={isActive ? CHEVRON_RIGHT_ACTIVE : CHEVRON_RIGHT} width={"5px"} alt="chevronRight" />
          </div> 
        }
          
    </div>
  )
}

export default SelectNavBox